import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import TableList from "@/components/TableList/index.vue";
import { fmtSize } from "@com/utils/data-format";
export default defineComponent({
    name: "BindProjectTable",
    components: {
        TableList: TableList
    },
    props: {
        dialogConfig: {
            type: definePropType(Object),
            default: function() {}
        },
        tableList: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        message: {
            type: String,
            default: ""
        },
        progress: {
            type: String,
            default: ""
        }
    },
    setup: function setup() {
        var columnConfig = [
            {
                label: "\u5E73\u53F0",
                prop: "platform"
            },
            {
                label: "\u521B\u610F\u7C7B\u578B",
                prop: "languages"
            },
            {
                label: "\u6E20\u9053/\u8BED\u8A00",
                prop: "channel",
                params: {
                    innerText: function innerText(param) {
                        var row = param.row;
                        if (row && row.channel) {
                            return row.channel + ": " + row.languages;
                        }
                        return "-";
                    }
                }
            },
            {
                label: "\u7D20\u6750\u7C7B\u578B",
                prop: "category_name"
            },
            {
                label: "\u64CD\u4F5C\u65F6\u95F4",
                prop: "updated_time",
                type: "time",
                params: {
                    format: "{y}-{m}-{d}  {h}:{i}:{s}"
                }
            },
            {
                label: "\u63D0\u6D4B\u72B6\u6001",
                prop: "status"
            },
            {
                label: "\u5305\u4F53\u5927\u5C0F",
                prop: "file_size",
                width: 100,
                params: {
                    innerHTML: function innerHTML(param) {
                        var row = param.row;
                        return row.file_size ? fmtSize(row.file_size) : "-";
                    }
                }
            },
            {
                label: "\u5931\u8D25\u539F\u56E0",
                prop: "message"
            }, 
        ];
        return {
            columnConfig: columnConfig
        };
    }
});
